import * as React from "react";
import PropTypes from "prop-types";
import styled, { keyframes } from "styled-components";
import { cancelIcon } from "./SvgIcons.js";

class NotificationBar extends React.Component {
  constructor(props) {
    super(props);
    this.timeoutVar = null;
    this.state = {
      type: this.props.type,
      autoClose: this.props.autoClose,
    };
  }

  componentWillMount() {
    if (this.props.open) {
      clearTimeout(this.timeoutVar);
      this.autoCloseFunc(this.props.autoClose);
    }

    if (!this.props.disableOnclickListener) {
      document.addEventListener("click", this.handleScreenClick, false);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      (!this.props.autoClose && nextProps.autoClose) ||
      (this.props.open === false && nextProps.open)
    ) {
      clearTimeout(this.timeoutVar);
      this.autoCloseFunc(nextProps.autoClose);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutVar);
    if (!this.props.disableOnclickListener) {
      document.removeEventListener("click", this.handleScreenClick);
    }
  }

  handleScreenClick = () => {
    this.close();
  };

  close() {
    if (this.props.onHandleClose) {
      this.props.onHandleClose();
    }
  }

  autoCloseFunc(autoClose) {
    const interval = 5000;
    if (autoClose) {
      this.timeoutVar = setTimeout(() => {
        if (this.props.open) this.close();
      }, interval);
    }
  }

  render() {
    const { message } = this.props;

    return (
      <Wrapper
        className={`${this.props.type} ${this.props.animation} ${this.props.open ? "show" : "hide"
          } ${this.props.onHandleClose ? "with-close-btn" : ""}`}
        style={{ ...this.props.style }}
      >
        <div className="mask"></div>
        {(() => {
          let textStyle = this.props.textStyle ? this.props.textStyle : {};

          if (Array.isArray(message)) {
            return (
              <div className="text-container">
                {message.map((m, i) => (
                  <span className="text" key={i} style={{ ...textStyle }}>
                    {m}
                  </span>
                ))}
              </div>
            );
          } else {
            return (
              <span className="text" style={{ ...textStyle }}>
                {this.props.message}
                {this.props.children}
              </span>
            );
          }
        })()}
        {(() => {
          if (this.props.onHandleClose) {
            return <div className="icon" onClick={() => this.close()}></div>;
          }
        })()}
      </Wrapper>
    );
  }
}

NotificationBar.defaultProps = {
  type: "success",
  open: false,
  autoClose: true,
  disableOnclickListener: false,
  animation: "bounce",
};

NotificationBar.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  type: PropTypes.string,
  open: PropTypes.bool,
  onHandleClose: PropTypes.func,
  autoClose: PropTypes.bool,
  disableOnclickListener: PropTypes.bool,
  animation: PropTypes.string,
  textStyle: PropTypes.object,
  style: PropTypes.object,
  children: PropTypes.node,
};

const bounce = keyframes`
  0% { transform: translateY(-52px);}
  25% { transform: translateY(0);}
  50% { transform: translateY(-10px);}
  100% { transform: translateY(0);}
`;

const fadeIn = keyframes`
   0% {opacity: 0;}
   100% {opacity: 1;}
`;

const fadeOut = keyframes`
   0% {opacity: 1;}
   100% {opacity: 0;}
`;

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  line-height: 39px;
  margin: 0 auto;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.16);
  font-size: 13px;
  font-weight: 600;
  transform: translateY(-52px);
  transition: transform 240ms ease-in;
  min-width: 200px;
  minheight: 40px;
  box-sizing: border-box;
  position: relative;

  &.with-close-btn {
    padding: 0px 70px;
  }

  &.show {
    animation: ${(props) => {
    if (props.className.includes("fade")) {
      return `${fadeIn} 800ms ease-in`;
    } else if (props.className.includes("none")) {
      return "none";
    } else {
      return `${bounce} 240ms ease-in`;
    }
  }};
    transform: translateY(0);
    opacity: 1;
  }

  &.hide {
    animation: ${(props) => {
    if (props.className.includes("fade")) {
      return `${fadeOut} 800ms ease-out`;
    } else {
      return `all 240ms ease-in`;
    }
  }};
    opacity: 0;
    height: 0;
  }

  & .text-container {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  & .text {
    text-align: center;
    width: 100%;
  }

  &.success {
    color: #1a65ff;
    border: 1px solid #1a65ff;
    background: #f2f6ff;
    border-radius: 2px;
  }
  &.error {
    color: #f03a47;
    border: 1px solid #f03a47;
    background: #fff2f2;
    border-radius: 2px;
    white-space: pre-wrap;
  }
  &.ghost {
    color: #71737b;
    border: 1px solid #d8dbdf;
    background: #eceef0;
    border-radius: 2px;
  }

  &.green {
    color: #3d8d5f;
    border: 1px solid #3d8d5f;
    background: #e6fff1;
    border-radius: 2px;
  }

  &.yellow {
    color: #181819;
    border: 1px solid #d6b330;
    background: #fff3c6;
    border-radius: 2px;
  }

  & .icon {
    height: 24px;
    width: 24px;
    margin-right: 10px;
    position: absolute;
    right: 0;
    top: 6px;
    background: url(${cancelIcon}) no-repeat;
    mask: url(${cancelIcon}) no-repeat;
    background: ${(props) => {
    if (props.className.includes("success")) {
      return "#1A65FF";
    } else if (props.className.includes("ghost")) {
      return "#71737B";
    } else if (props.className.includes("green")) {
      return "#3D8D5F";
    } else if (props.className.includes("yellow")) {
      return "#181819";
    } else {
      return "#F03A47";
    }
  }};
    cursor: pointer;
  }
`;
export default NotificationBar;



// WEBPACK FOOTER //
// ./src/components/Parts/NotificationBar.jsx